import script from "./videoTime.vue?vue&type=script&setup=true&lang=js"
export * from "./videoTime.vue?vue&type=script&setup=true&lang=js"

import "./videoTime.vue?vue&type=style&index=0&id=0ce99faf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ce99faf"]])

export default __exports__